import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Search, Building2 } from "lucide-react";

export function CustomerPicker({ open, onOpenChange, onSelect }) {
  const [list, setList] = useState([]);
  const [search, setSearch] = useState("");

  useEffect(() => { if (!open) setSearch(""); }, [open]);

  useEffect(() => {
    if (!open) return;
    const t = setTimeout(() => {
      api.get("/customers", { params: { search, limit: 60 } }).then((r) => setList(r.data.customers));
    }, 250);
    return () => clearTimeout(t);
  }, [search, open]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-xl">
        <DialogHeader><DialogTitle className="font-display">Vybrat odběratele</DialogTitle></DialogHeader>
        <div className="relative">
          <Search className="h-4 w-4 absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
          <Input data-testid="customer-picker-search" placeholder="Hledat název, IČO, město…" value={search}
            onChange={(e) => setSearch(e.target.value)} className="pl-9" autoFocus />
        </div>
        <div className="max-h-80 overflow-auto border border-border rounded-lg divide-y divide-border">
          {list.map((c) => (
            <button key={c.id} data-testid={`customer-pick-${c.id}`}
              onClick={() => { onSelect(c); onOpenChange(false); }}
              className="w-full flex items-center gap-3 px-4 py-2.5 text-left hover:bg-muted transition-colors">
              <Building2 className="h-4 w-4 text-muted-foreground shrink-0" />
              <div>
                <div className="text-sm font-medium">{c.name}</div>
                <div className="text-xs text-muted-foreground">
                  {[c.ico && `IČO ${c.ico}`, c.city, c.code].filter(Boolean).join(" · ")}
                </div>
              </div>
            </button>
          ))}
          {list.length === 0 && <div className="px-4 py-8 text-center text-sm text-muted-foreground">Nic nenalezeno.</div>}
        </div>
      </DialogContent>
    </Dialog>
  );
}
